import React from "react";
import { useDimensions } from "../../Util";
import ContentWithLineLimit from "../../UtilComps/ContentWithLineLimit";
import { useNavigate } from "react-router-dom";

const WalletAndMotivationContainer = ({ walletBalance }) => {

    const { w, h } = useDimensions();
    const navigate = useNavigate();

    const walletandmotivationContainer = {
        gridRow: w > h ? "1 / 17" : "1/6",
        gridColumn: w > h ? "12 / 18" : "30/51",
        background: "#393E46",
        display: "flex",
        justifyContent: w > h ? "center" : "space-between",
        alignItems: "center",
        flexDirection: w > h ? "column" : "row"
    }

    const imageWallet = {
        height: w > h ? 7 * h : 4 * h,
        width: w > h ? 7 * h : 4 * h,
        marginTop: "5px"
    }

    const imagePill = {
        height: w > h ? 5 * h : 4 * h,
        width: w > h ? 10 * h : 8 * h,
        marginTop: "5px",
        marginRight:w>h?"0px":"7px",
        cursor:"pointer"
    }

    const walletBalanceFont = {
        fontFamily: "Outfit",
        fontSize: w > h ? "clamp(28px,2.5vh,40px)" : "clamp(18px,1.35vh,22px)",
        fontWeight: 900,
        marginTop: w > h ? 2 * h : 2 * h,
        color: "#BEBEBE"
    }

    const motivationPillClicked=()=>{
        navigate("/popup",{state:{type:"motivationPill"}})
    }

    return <div id="wallet-and-motivation-container" style={walletandmotivationContainer}>
        <div style={{display:"flex",justifyContent:"center",
            alignItems:"center",flexDirection:w>h?"column":"row",
            marginLeft:w>h?"0px":4*w
            }}>
            <img src={`/images/wallet.png`} style={imageWallet} alt="Description" />
            <p style={walletBalanceFont}>${walletBalance}</p>
        </div>
        <div id="motivation" style={{ margin: w > h ? "10px" : "5px", textAlign: "center" }}>
            <ContentWithLineLimit
                fontColor={"#00ADB5"}
                Fontsref={w > h ? "smallest-font-desktop" : "smallest-font-mobile"}
                content={"Motivation Pill"}
                lineLimit={2}
            ></ContentWithLineLimit>
            <img src={`/images/pill.png`} style={imagePill} onClick={motivationPillClicked} alt="Description" />
        </div>
    </div>
}

export default WalletAndMotivationContainer;